module.exports = __webpack_public_path__ + "static/media/meronex.f02881a8.png";